export class Setting {
    id: number;
    type: string;
    data: string;
    language: string;
}